// extracted by mini-css-extract-plugin
export default {"container":"arh2qf","header":"cJscj1","content":"cTdFFO","description":"clf9mN","controls":"wdbmEY","isLayoutTextOnImage":"nAaNon"};